import { LinearGradient, type LinearGradientProps } from 'expo-linear-gradient';
import type { FC, PropsWithChildren } from 'react';
import { StyleSheet } from 'react-native';

import { useAppTheme } from '@/styles/hooks/useAppTheme';

type Props = PropsWithChildren<{
  colors?: LinearGradientProps['colors'];
  locations?: LinearGradientProps['locations'];
  testID?: string;
}>;

export const GradientBackground: FC<Props> = ({
  children,
  colors,
  locations,
  testID
}) => {
  const theme = useAppTheme();

  return (
    <LinearGradient
      style={styles.gradient}
      colors={
        colors ?? [
          theme.colors.surfaceContainer,
          theme.colors.secondaryContainer,
          theme.colors.secondaryContainer
        ]
      }
      locations={locations}
      testID={testID}
    >
      {children}
    </LinearGradient>
  );
};

const styles = StyleSheet.create({
  gradient: { flex: 1 }
});
